//@ts-check
import { Box, Radio, Typography } from '@mui/material';
import COLORS from '@/resources/style/Themes';

/** @param {{ selected: boolean, onClick: () => void, label: string, description?: string }} props */
function RadioOptionBox({ selected, onClick, label, description }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        p: 2,
        border: `2px solid ${selected ? COLORS.BLUE_CRAYOLA : COLORS.LIGHT_GRAY}`,
        borderRadius: 2,
        cursor: 'pointer',
        backgroundColor: selected ? 'rgba(32, 129, 239, 0.06)' : 'transparent',
        transition: 'all 0.15s ease',
        '&:hover': {
          borderColor: COLORS.BLUE_CRAYOLA,
        },
      }}
    >
      <Radio checked={selected} onChange={onClick} sx={{ p: 0, mt: '2px' }} />
      <Box>
        <Typography variant="body1" fontWeight={selected ? 600 : 400}>
          {label}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default RadioOptionBox;
